import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import { mapState } from "vuex";

export default {
    name: 'ProfileNetworks',
    components: {
        navigation,
        bottom
    },
    computed: {
        ...mapState('dashboard', {
            activeTab: state => state.activeTab,
            currentUser: state => state.currentUser.uid,
            userProfile: state => state.userProfile,
            userProfileLoaded: state => state.userProfileLoaded,
        }),
        networkFacebook: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_facebook'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_facebook',
                    networkToEditValue: value,
                });
            }
        },
        networkTwitter: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_twitter'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_twitter',
                    networkToEditValue: value,
                });
            }
        },
        networkSnapchat: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_snapchat'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_snapchat',
                    networkToEditValue: value,
                });
            }
        },
        networkInstagram: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_instagram'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_instagram',
                    networkToEditValue: value,
                });
            }
        },
        networkTwitch: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_twitch'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_twitch',
                    networkToEditValue: value,
                });
            }
        },
        networkTiktok: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_tiktok'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_tiktok',
                    networkToEditValue: value,
                });
            }
        },
        networkVimeo: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_vimeo'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_vimeo',
                    networkToEditValue: value,
                });
            }
        },
        networkYoutube: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_youtube'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_youtube',
                    networkToEditValue: value,
                });
            }
        },
        networkLinkedin: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_linkedin'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_linkedin',
                    networkToEditValue: value,
                });
            }
        },
        networkGithub: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_github'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_github',
                    networkToEditValue: value,
                });
            }
        },
        networkWebsite: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_website'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_website',
                    networkToEditValue: value,
                });
            }
        },
        networkPaypal: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_paypal'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_paypal',
                    networkToEditValue: value,
                });
            }
        },
        networkXboxlive: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_xboxlive'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_xboxlive',
                    networkToEditValue: value,
                });
            }
        },
        networkPsn: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_psn'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_psn',
                    networkToEditValue: value,
                });
            }
        },
        networkSteam: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_steam'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_steam',
                    networkToEditValue: value,
                });
            }
        },
        networkOrigin: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_origin'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_origin',
                    networkToEditValue: value,
                });
            }
        },
        networkBattlenet: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_battlenet'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_battlenet',
                    networkToEditValue: value,
                });
            }
        },
        networkUplay: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_uplay'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_uplay',
                    networkToEditValue: value,
                });
            }
        },
        networkEpicgames: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_epicgames'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_epicgames',
                    networkToEditValue: value,
                });
            }
        },
        networkSpotify: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_spotify'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_spotify',
                    networkToEditValue: value,
                });
            }
        },
        networkSoundcloud: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_soundcloud'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_soundcloud',
                    networkToEditValue: value,
                });
            }
        },
        networkDeezer: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_deezer'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_deezer',
                    networkToEditValue: value,
                });
            }
        },
        networkApplemusic: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_applemusic'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_applemusic',
                    networkToEditValue: value,
                });
            }
        },
        networkBelievemusic: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_believemusic'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_believemusic',
                    networkToEditValue: value,
                });
            }
        },
        networkSkype: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_skype'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_skype',
                    networkToEditValue: value,
                });
            }
        },
        networkTeams: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_teams'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_teams',
                    networkToEditValue: value,
                });
            }
        },
        networkDiscord: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_discord'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_discord',
                    networkToEditValue: value,
                });
            }
        },
        networkDeviantart: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_deviantart'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_deviantart',
                    networkToEditValue: value,
                });
            }
        },
        networkPinterest: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_pinterest'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_pinterest',
                    networkToEditValue: value,
                });
            }
        },
        networkDribbble: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_dribbble'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_dribbble',
                    networkToEditValue: value,
                });
            }
        },
        networkTipeee: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_tipeee'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_tipeee',
                    networkToEditValue: value,
                });
            }
        },
        networkPatreon: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_patreon'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_patreon',
                    networkToEditValue: value,
                });
            }
        },
        networkKickstarter: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_kickstarter'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_kickstarter',
                    networkToEditValue: value,
                });
            }
        },
        networkGofundme: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_gofundme'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_gofundme',
                    networkToEditValue: value,
                });
            }
        },
        networkLeetchi: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_leetchi'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_leetchi',
                    networkToEditValue: value,
                });
            }
        },
        networkUtip: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_utip'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_utip',
                    networkToEditValue: value,
                });
            }
        },
        networkEbay: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_ebay'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_ebay',
                    networkToEditValue: value,
                });
            }
        },
        networkLeboncoin: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_leboncoin'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_leboncoin',
                    networkToEditValue: value,
                });
            }
        },
        networkVinted: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_vinted'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_vinted',
                    networkToEditValue: value,
                });
            }
        },
        networkOnlyfans: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_onlyfans'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_onlyfans',
                    networkToEditValue: value,
                });
            }
        },
        networkMym: {
            get() {
                return this.$store.state.dashboard.userProfile.networks['network_mym'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserNetworks", {
                    networkToEdit: 'network_mym',
                    networkToEditValue: value,
                });
            }
        },
    },
    methods: {

        saveNetworks(evt) {
            evt.preventDefault();
            this.$store.dispatch('dashboard/saveUserNetworks');
        }

    }
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/partials/dashboard-networks/dashboard-networks.js